module.exports = function() {
  return new Worker(__webpack_public_path__ + "3967efec8fa1997a.worker.js");
};